import React, { ReactElement } from "react";
import DashboardRoutes from "./routes/AppRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import AuthInit from "./components/layout/AuthInit";
import AppRoutes from "./routes/AppRoutes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App(): ReactElement {
  const hostname = window.location.hostname;
  const isDashboard = hostname.startsWith("app.");

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position="top-right" closeButton />
      <AuthInit>
        <AppRoutes />
      </AuthInit>
    </QueryClientProvider>
  );
}

export default App;
